export interface IState {
  title: string;
  preamble: string;
  searchResult: ISearchResult;
  query: string;
  searchedQuery: string;
  templateFilter: ITemplateFilter[];
  hitsPerPage: number;
  currentPage: number;
  endpoints: {
    searchURL: string;
  };
  focus: IFocus;
  suggestion?: string;
  translations: ITranslations;
  amountOfShowingHits: number;
  count: number;
  currentlyShowingHits: any;
}
export interface ITranslations {
  searchUKA: string;
  filterByType: string;
  allTypes: string;
  showMore: string;
  showing: string;
  outOf: string;
  pageTypePicked: string;
  pageTypesPicked: string;
  clearAllFilters: string;
  noHitsHeading: string;
  tryThis: string;
  checkSpelling: string;
  trySynonym: string;
  lessSpecificKeywords: string;
  searchResultFor: string;
  searchResult: string;
  weFound: string;
  hit: string;
  hits: string;
  matchingYourQuery: string;
  didYouMean: string;
  placeholder: string;
  clearQuery: string;
  search: string;
}
export interface IFocus {
  shouldFocus: boolean;
  index: number;
}
export interface ISearchResult {
  searchHits: any;
  totalHits: number;
  suggestion?: string;
}
export interface ISearchHit {
  type: string;
  title: string;
  breadcrumbs: string;
}
export interface ITemplateFilter {
  name: string;
  id: string;
  selected: boolean;
}

const deafultState: IState = {
  title: "",
  preamble: "",
  searchResult: {
    searchHits: [],
    totalHits: 0,
  },
  query: "",
  searchedQuery: "",
  templateFilter: [],
  hitsPerPage: 10,
  currentPage: 0,
  endpoints: {
    searchURL: "",
  },
  focus: {
    shouldFocus: false,
    index: 0,
  },
  suggestion: undefined,
  translations: {
    searchUKA: "",
    filterByType: "",
    allTypes: "",
    showMore: "",
    showing: "",
    outOf: "",
    pageTypePicked: "",
    pageTypesPicked: "",
    clearAllFilters: "",
    noHitsHeading: "",
    tryThis: "",
    checkSpelling: "",
    trySynonym: "",
    lessSpecificKeywords: "",
    searchResultFor: "",
    searchResult: "",
    weFound: "",
    hit: "",
    hits: "",
    matchingYourQuery: "",
    didYouMean: "",
    placeholder: "",
    clearQuery: "",
    search: "",
  },
  amountOfShowingHits: 0,
  count: 0,
  currentlyShowingHits: {},
};

export default deafultState;
